import { commonChangeMediaProcess } from '@/helpers/mediaUtils';

export const applyQuestionnaireResumeOpen = ({
  questionnaireResumePosition,
  contents,
  restartProgressForActiveSlide,
}) => {
  const isMobileCircle = window.storeeelItems?.isMobile && window.storeeelItems?.frame === 'circle';
  if (!isMobileCircle) return false;
  if (!questionnaireResumePosition || !Array.isArray(contents)) return false;

  const resumeIndex = Number(questionnaireResumePosition.moviePosition);
  if (!Number.isFinite(resumeIndex) || resumeIndex <= 0) return false;

  const currentGroupId = String(window.iconId || '').split('-').pop();
  const resumeGroupId = String(questionnaireResumePosition.iconId || '').split('-').pop();
  const currentMoviePosition = Number(window.moviePosition);
  if (resumeGroupId && currentGroupId && resumeGroupId !== currentGroupId) return false;
  if (Number.isFinite(currentMoviePosition) && currentMoviePosition !== resumeIndex) {
    // 広告スキップなどで次グループへ進んだ場合は、通常のグループ遷移として扱う。
    return false;
  }

  const resumedContent = contents[resumeIndex];
  if (!resumedContent) return false;

  // アンケート回答後にモーダルを再生成した直後は、選択中のコンテンツ位置を即時で復元する。
  window.__storeeelSkipInitialPlayMediaViewTracking = true;
  commonChangeMediaProcess(contents);
  restartProgressForActiveSlide?.(String(resumedContent.id || ''));

  return true;
};
